import { TranslationDictionary } from './types';

const nl: TranslationDictionary = {    '2FA Activate': '2FA activeren',
    'Active client': 'Actieve klant',
    'Active hotel': 'Actief hotel',
    'Add cancellation policy': 'Annuleringsvoorwaarden toevoegen',
    'Add commission': 'Commissie toevoegen',
    'Add contact': 'Contact toevoegen',
    'Add contacts to Mailchimp': 'Contacten toevoegen aan Mailchimp',
    'Add period': 'Periode toevoegen',
    'Add room price': 'Kamerprijs toevoegen',
    'Additional image': 'Extra afbeelding',
    'Additional information': 'Aanvullende informatie',
    Admin: 'Admin',
    'All reservations': 'Alle reserveringen',
    'Business Hotel Service': 'Business Hotel Service',
    International: 'International',
    Breakfast: 'Ontbijt',
    Cancel: 'Annuleren',
    Cancelled: 'Geannuleerd',
    'Cancellation policy': 'Annuleringsbeleid',
    'Change password': 'Wachtwoord wijzigen',
    City: 'Stad',
    'City tax': 'Toeristenbelasting',
    Client: 'Klant',
    'Client Information': 'Klantinformatie',
    'Client account': 'Klantaccount',
    'Client address': 'Klantadres',
    'Client image': 'Klantafbeelding',
    'Client name': 'Klantnaam',
    Clients: 'Klanten',
    CMS: 'CMS',
    Commission: 'Commissie',
    Confirmed: 'Bevestigd',
    Contacts: 'Contacten',
    Country: 'Land',
    'Create registration form': 'Registratieformulier maken',
    'Create training': 'Training maken',
    'Credit Card': 'Creditcard',
    'Credit card name': 'Naam creditcard',
    'Credit card number': 'Creditcardnummer',
    'Country content': 'Landinhoud',
    Currency: 'Valuta',
    Delete: 'Verwijderen',
    Dutch: 'Nederlands',
    'Dutch template': 'Nederlands sjabloon',
    Edit: 'Bewerken',
    Email: 'E-mail',
    English: 'Engels',
    'English template': 'Engels sjabloon',
    'Enter the authentication code supplied by your Authenticator app.': 'Voer de authenticatiecode uit uw Authenticator-app in.',
    'Expiration month': 'Vervalmaand',
    'Expiration year': 'Vervaljaar',
    Export: 'Exporteren',
    'Extra remarks (only visible for BHS)': 'Extra opmerkingen (alleen zichtbaar voor BHS)',
    'Forgot password?': 'Wachtwoord vergeten?',
    'Enter your email address and we will send a password reset link.': 'Voer uw e-mailadres in en wij sturen een link om uw wachtwoord te resetten.',
    'Send reset link': 'Resetlink verzenden',
    'From date': 'Van datum',
    'Get price': 'Prijs ophalen',
    'Google Authenticator verification is required for your account.': 'Google Authenticator-verificatie is vereist voor uw account.',
    'Guest name': 'Gastnaam',
    'Guest pays': 'Gast betaalt',
    Hotel: 'Hotel',
    'Hotel Information': 'Hotelinformatie',
    'Hotel address': 'Hoteladres',
    'Hotel address same as postal address': 'Hoteladres is gelijk aan postadres',
    'Hotel logo': 'Hotellogo',
    'Hotel name': 'Hotelnaam',
    'Hotel name (invoice)': 'Hotelnaam (factuur)',
    Hotels: 'Hotels',
    Images: 'Afbeeldingen',
    Invoice: 'Factuur',
    'Invoice Address': 'Factuuradres',
    'Invoice address same as postal address': 'Factuuradres is gelijk aan postadres',
    'Invoice on account': 'Factuur op rekening',
    'Invoice received': 'Factuur ontvangen',
    'Invoice reference': 'Factuurreferentie',
    Invoices: 'Facturen',
    'Interview report (only visible for BHS)': 'Interviewverslag (alleen zichtbaar voor BHS)',
    'Item records': 'Itemrecords',
    'Keep a safe copy of the 16-digit secret code.': 'Bewaar een veilige kopie van de 16-cijferige geheime code.',
    Language: 'Taal',
    Login: 'Inloggen',
    'Login details': 'Inloggegevens',
    Logout: 'Uitloggen',
    'Make all final': 'Alles definitief maken',
    'Make final': 'Definitief maken',
    Month: 'Maand',
    Name: 'Naam',
    Netherlands: 'Nederland',
    New: 'Nieuw',
    Nights: 'Nachten',
    'Number of nights': 'Aantal nachten',
    Open: 'Open',
    'Open menu': 'Menu openen',
    'Open reservations': 'Open reserveringen',
    Other: 'Overig',
    'Other commission agreements': 'Overige commissieafspraken',
    Page: 'Pagina',
    Password: 'Wachtwoord',
    Pending: 'In behandeling',
    Period: 'Periode',
    Person: 'Persoon',
    'Person name': 'Naam persoon',
    Phone: 'Telefoon',
    'Phone number': 'Telefoonnummer',
    'Postal Address': 'Postadres',
    'Post/invoice address': 'Post-/factuuradres',
    Price: 'Prijs',
    Print: 'Afdrukken',
    Rates: 'Tarieven',
    Received: 'Ontvangen',
    Remarks: 'Opmerkingen',
    'Reservation Details': 'Reserveringsgegevens',
    'Reservation confirmed by': 'Reservering bevestigd door',
    'Reservation number hotel': 'Reserveringsnummer hotel',
    'Reservation number': 'Reserveringsnummer',
    'Reservation period': 'Reserveringsperiode',
    Reservations: 'Reserveringen',
    'Reset 2FA key': '2FA-sleutel resetten',
    'Reset password': 'Wachtwoord resetten',
    'Create a new password for your BHS account.': 'Maak een nieuw wachtwoord aan voor uw BHS-account.',
    'New password': 'Nieuw wachtwoord',
    'Back to login': 'Terug naar inloggen',
    'Room Reservation': 'Kamerreservering',
    'Room reservation': 'Kamerreservering',
    'Room prices period': 'Kamerprijzenperiode',
    'Room type': 'Kamertype',
    Save: 'Opslaan',
    'Scan the QR code with the Authenticator app.': 'Scan de QR-code met de Authenticator-app.',
    'Search by name': 'Zoeken op naam',
    'Select Client': 'Klant selecteren',
    'Select Hotel': 'Hotel selecteren',
    Send: 'Verzenden',
    'Send login credentials': 'Inloggegevens verzenden',
    'Show cost': 'Kosten tonen',
    'Show turnover': 'Omzet tonen',
    'Sign in to manage BHS hotel reservations.': 'Log in om BHS hotelreserveringen te beheren.',
    Start: 'Start',
    Submit: 'Verzenden',
    Templates: 'Sjablonen',
    'To date': 'Tot datum',
    Total: 'Totaal',
    'Total commission': 'Totale commissie',
    'Total cost': 'Totale kosten',
    'Total turnover': 'Totale omzet',
    'Type of card': 'Kaarttype',
    'Use VAT of the Hotel instead of the VAT of the Country': 'Gebruik de btw van het hotel in plaats van de btw van het land',
    User: 'Gebruiker',
    VAT: 'Btw',
    'VAT number': 'Btw-nummer',
    Welcome: 'Welkom',
    'Add row': 'Rij toevoegen',
    'Additional Information': 'Aanvullende informatie',
    Arrangement: 'Arrangement',
    'Arrival date': 'Aankomstdatum',
    'BHS account': 'BHS-account',
    'BHS double': 'BHS tweepersoons',
    'BHS single': 'BHS eenpersoons',
    BHR: 'BHR',
    'Booking Changes': 'Boekingswijzigingen',
    'CC client': 'CC klant',
    'CC hotel': 'CC hotel',
    'Check reservation status': 'Reserveringsstatus controleren',
    Clear: 'Wissen',
    'Commission totals are calculated from the selected reservation period and invoice status.':
      'Commissietotalen worden berekend op basis van de geselecteerde reserveringsperiode en factuurstatus.',
    'Confirm password': 'Wachtwoord bevestigen',
    'Confirmed reservations': 'Bevestigde reserveringen',
    'Contact person client': 'Contactpersoon klant',
    'Contact person hotel': 'Contactpersoon hotel',
    'Date arrival': 'Aankomstdatum',
    'Departure date': 'Vertrekdatum',
    FB: 'FB',
    'Grand total': 'Eindtotaal',
    'Hide password': 'Wachtwoord verbergen',
    'Install the Google Authenticator app on your mobile device.': 'Installeer de Google Authenticator-app op uw mobiele apparaat.',
    'Last Changed Prices': 'Laatst gewijzigde prijzen',
    'Mail for invoice': 'Mail voor factuur',
    'Manage the client image or logo used for this client profile.': 'Beheer de klantafbeelding of het logo voor dit klantprofiel.',
    'Manage country-specific CMS content and settings.': 'Beheer landspecifieke CMS-inhoud en instellingen.',
    'Manage the visual assets shown for the selected hotel.': 'Beheer de visuele bestanden voor het geselecteerde hotel.',
    'Never share this secret code or QR code with anyone.': 'Deel deze geheime code of QR-code nooit met iemand.',
    'Remove contact row': 'Contactrij verwijderen',
    'Remove period row': 'Perioderij verwijderen',
    Remove: 'Verwijderen',
    'Replace file': 'Bestand vervangen',
  'Review reservation commission and finalize the invoice.': 'Controleer de reserveringscommissie en maak de factuur definitief.',
  'Review hotels with recent room or other price changes.': 'Controleer hotels met recente wijzigingen in kamerprijzen of overige prijzen.',
  'Review reservation changes before finalizing invoices.': 'Controleer reserveringswijzigingen voordat u facturen definitief maakt.',
  'Review room reservation costs for the selected client and year.': 'Bekijk de kamerreserveringskosten voor de geselecteerde klant en het jaar.',
  'Review turnover for the selected hotel and year.': 'Bekijk de omzet voor het geselecteerde hotel en jaar.',
  'Review reservations where booking details have changed.': 'Controleer reserveringen waarvan de boekingsgegevens zijn gewijzigd.',
  'No reservation changes found for the selected filters.': 'Geen reserveringswijzigingen gevonden voor de geselecteerde filters.',
  'Reset 2FA': '2FA resetten',
    'Reset the authenticator setup for this hotel user.': 'Reset de authenticator-instelling voor deze hotelgebruiker.',
    'Reservation ID': 'Reserverings-ID',
    row: 'rij',
    Room: 'Kamer',
    'Secret code': 'Geheime code',
    'Show password': 'Wachtwoord tonen',
    'Two-factor authentication': 'Twee-factor-authenticatie',
    Toggle: 'Schakel',
    'Update the selected CMS content in Dutch and English.': 'Werk de geselecteerde CMS-inhoud bij in het Nederlands en Engels.',
    'Upload an optional supporting image': 'Upload een optionele aanvullende afbeelding',
    'Upload the logo or profile image used for this client': 'Upload het logo of profielbeeld voor deze klant',
    'Upload the logo shown for this hotel': 'Upload het logo voor dit hotel',
    'VAT (0%)': 'Btw (0%)',
    visibility: 'zichtbaarheid',
    Preview: 'Voorbeeld',
    'Choose file': 'Bestand kiezen',
    'Date changed other prices': 'Datum wijziging overige prijzen',
    'Date changed room prices': 'Datum wijziging kamerprijzen',
    'PNG, JPG, SVG or PDF': 'PNG, JPG, SVG of PDF',
    'Price Changes History': 'Prijshistorie',
    'Select all': 'Alles selecteren',
    'Send Commission': 'Commissie verzenden',
    Year: 'Jaar',
    Yes: 'Ja',
    No: 'Nee',
    Zipcode: 'Postcode'
};

export default nl;
